export function operacaoAfericaoVeiculoInRequest(params = {}) {
  return {
    type: '@operacaoafericaoveiculo/AFERICAOVEICULO_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoAfericaoVeiculo(veic_placa) {
  return {
    type: '@operacaoafericaoveiculo/FIND_AFERICAOVEICULO',
    payload: { veic_placa },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoafericaoveiculo/FAILED_REQUEST',
  };
}

export function deleteOperacaoAfericaoVeiculo(veic_placa, params) {
  return {
    type: '@operacaoafericaoveiculo/DELETE_AFERICAOVEICULO',
    payload: { veic_placa, params },
  };
}

export function updateOperacaoAfericaoVeiculo(operacaoafericaoveiculo, params) {
  return {
    type: '@operacaoafericaoveiculo/UPDATE_AFERICAOVEICULO',
    payload: { operacaoafericaoveiculo, params },
  };
}

export function storeOperacaoAfericaoVeiculo(operacaoafericaoveiculo, params) {
  return {
    type: '@operacaoafericaoveiculo/STORE_AFERICAOVEICULO',
    payload: { operacaoafericaoveiculo, params },
  };
}

export function successInRequest(
  operacaoafericaoveiculo,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaoafericaoveiculo/SUCCESS_IN_REQUEST',
    payload: {
      operacaoafericaoveiculo,
      page,
      pageSize,
      totalCount,
      totalPages,
    },
  };
}

export function successRequest(operacaoafericaoveiculo) {
  return {
    type: '@operacaoafericaoveiculo/SUCCESS_REQUEST',
    payload: { operacaoafericaoveiculo },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoafericaoveiculo/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoafericaoveiculo/RECORD_FILTERING',
    payload: { params },
  };
}
